/**
 * @fileoverview Agent definition for draft-judge-v2.
 *
 * This agent reviews drafting history to determine if the draft is
 * satisfactory or needs more iteration.
 *
 * @category narrative.prose.judgment
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'draft-judge-v2',
  kind: 'primitive',
  name: 'Draft Judge',
  description: 'Reviews drafting history to determine if the draft is satisfactory or needs more iteration.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-10',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.judgment',
    usedBy: [],
    usedInComposites: [
      'iterative-refinement-v2',
    ],
    relatedAgents: [
      'run-refine-full-v2',
    ],
  },
};
